/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextActionCheckIcon16Regular = forwardRef('TextActionCheckIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.25 4A.75.75 0 0 1 3 3.25h10a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 4Z" }),
        React.createElement("path", { d: "M3 7.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M3 11.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M15.28 11.53a.75.75 0 1 0-1.06-1.06l-2.97 2.97-1.47-1.47a.75.75 0 0 0-1.06 1.06l1.646 1.647a1.25 1.25 0 0 0 1.768 0l3.146-3.147Z" })));
});
